'use client'
import Image from 'next/image'
import { useEffect, useState } from 'react'
import useMeta from '@/store/meta'

export default function CCP_ImageFallback({ ...props }) {
  // Meta
  const { metaInfo } = useMeta()
  const fallbackCoverImage =
    metaInfo?.fallback_cover_image?.url ||
    'https://static.bangkokhospital.com/uploads/2024/04/backupcoverimg.jpg'
  const fallbackVideoCover =
    metaInfo?.fallback_video_cover?.url ||
    'https://static.bangkokhospital.com/uploads/2024/04/videocoverimage.jpg'
  const type = props.type || 'image'
  const fallbackSrc = type === 'image' ? fallbackCoverImage : fallbackVideoCover
  // Fallback Image
  const { hasgradient, src, alt, ...rest } = props
  const [imgSrc, setImgSrc] = useState(src)
  useEffect(() => {
    setImgSrc(src)
  }, [src])
  return (
    <>
      <Image
        {...rest}
        src={imgSrc}
        alt={alt || 'Image Fallback'}
        sizes="100%"
        onError={() => {
          setImgSrc(fallbackSrc)
        }}
      />
      {hasgradient ? (
        <>
          <div className="tw-absolute tw-inset-0 tw-bg-gradient-to-t tw-from-black/5 tw-via-transparent tw-to-transparent" />
          <div className="tw-absolute tw-inset-0 tw-bg-gradient-to-b tw-from-black/5 tw-via-transparent tw-to-transparent" />
        </>
      ) : null}
    </>
  )
}
